module.exports = {"person":0,"position":1,"location":2,"department":3,"organisation":4,"education":5}


//////////////////
// WEBPACK FOOTER
// ./js/modules/constants/ObjectTypeMapping.json
// module id = 49
// module chunks = 0